module.exports = "<list-workwaves-history></list-workwaves-history>\n"